import React from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "../../Components/Footer";
import { Header } from "../../Components/Header";

export const Layout = () => {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Header />
      <section className="flex-fill flex-grow">
        <Outlet />
      </section>
      <Footer />
    </div>
  );
};
